export class MathUtils {
    static calculatePercentage = (value: number, total: number, digits: number = 2): string => ((value / total) * 100).toFixed(digits);

    static getRandomInt = (min: number, max: number): number => {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min)) + min; // The maximum is exclusive and the minimum is inclusive
    };

    static isMultipleOf = (a: number, b: number): boolean => a % b === 0;

    static multiplesOf = (values: any[], n: number): any[] =>
        values.filter((value: any, index: number) => MathUtils.isMultipleOf(index, n));

    static inclusiveMultiplesOf = (values: any[], n: number): any[] =>
        values.filter((value: any, index: number) => MathUtils.isMultipleOf(index, n) || index === values.length - 1);
}
